import DesktopSidebar from './DesktopSidebar';
import DesktopBetSlipPanel from './DesktopBetSlipPanel';
import SupportChat from '../shared/SupportChat';
import SearchOverlay from '../search/SearchOverlay';
import HomeFooter from '../home/HomeFooter';
import '../../css/desktop/DesktopShell.css';

export default function DesktopShell({ activeTab, overlay, children }) {
  return (
    <div className="dsk">
      <DesktopSidebar activeTab={activeTab} />
      <main className="dsk-main">
        {children}
        <HomeFooter />
        {overlay}
      </main>
      <aside className="dsk-right">
        <DesktopBetSlipPanel />
      </aside>
      <SupportChat />
      <SearchOverlay />
    </div>
  );
}
